import { Component, Input } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { RosterType } from 'src/app/core/services/http/roster/enums/roster-types';
import { RosterUploadFileType } from "../../../../core/services/http/roster/enums/roster-upload-file-types";

@Component({
    selector: 'app-roster-general-settings',
    templateUrl: './roster-general-settings.component.html',
    styleUrls: ['./roster-general-settings.component.scss'],
    standalone: false
})
export class RosterGeneralSettingsComponent {
  @Input() form: UntypedFormGroup | undefined;
  rosterType = RosterType;
  rosterFileType = RosterUploadFileType;

  get sourceValue(): unknown {
    return this.form?.get('source')?.value;
  }

  get sourceIdValue(): unknown {
    return this.form?.get('sourceId')?.value;
  }

  get typeValue(): unknown {
    return this.form?.get('type')?.value;
  }

  get isExternalWithoutSourceId(): boolean {
    return this.sourceValue === this.rosterFileType.External && !this.sourceIdValue;
  }

  /** WCAG 3.3.1 — align aria-describedby / aria-invalid with app-form-error visibility */
  hasVisibleError(controlName: string): boolean {
    const c = this.form?.get(controlName);
    if (!c) {
      return false;
    }
    return c.errors !== null && (c.dirty === true || c.touched === true);
  }
}
